import * as auth from '@max/auth/state/auth.reducer';
import * as transaction from '@max/transaction/state/transaction.reducer';
import * as userManagement from '@max/usermanagement/state/usermanagement.reducer';
import { ActionReducerMap } from '@ngrx/store';

export interface AppState {
    authState: auth.AuthState;
    transactionState: transaction.TransactionState;
    userManagementState: userManagement.UserManagementState;
}

export const reducers: ActionReducerMap<AppState> = {
    authState: auth.reducer,
    transactionState: transaction.reducer,
    userManagementState: userManagement.reducer
};
